import { FC, memo, useMemo } from "react";
import "./avatar.scss";
import { Button } from "@components/button";
import { EditIcon } from "@components/icons";
import { getInitials } from "@utils/user.util";
import AvatarLoader from "./skeleton";

export type AvatarImageSize = "medium" | "large" | "small" | "x-small" | "profile";

interface AvatarProps {
  title?: string;
  imageUrl?: string;
  size?: AvatarImageSize;
  onEditImage?: () => void;
  loading?: boolean;
  className?: string;
  titleFormatter?: (title?: string) => string;
}

const AvatarComponent: FC<AvatarProps> = ({
  title,
  imageUrl,
  size = "small",
  onEditImage,
  loading,
  className,
  titleFormatter = getInitials,
}) => {
  const formattedTitle = useMemo(() => titleFormatter?.(title) || title, [title, titleFormatter]);
  return (
    <>
      {loading ? (
        <AvatarLoader size={size} />
      ) : (
        <div className={`user ${size || "small"} ${className}`}>
          {!imageUrl ? (
            <span className={`short-name ${formattedTitle}`}>{formattedTitle}</span>
          ) : (
            <img
              src={imageUrl}
              alt={formattedTitle}
              className="short-name"
              loading="eager"
              decoding="async"
            />
          )}
          {onEditImage ? (
            <Button onClick={onEditImage} className={`edit-image ${size}`}>
              <EditIcon color="#ffffff" />
            </Button>
          ) : null}
        </div>
      )}
    </>
  );
};

export const Avatar = memo(AvatarComponent);
